import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Link } from '@mui/material'
import type React from 'react'

interface Props {
  onClose: () => void
  onBack?: () => void
  showBack?: boolean
}

const DrawerHeader: React.FC<Props> = ({ onClose, onBack, showBack }) => (
  <Box
    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}
  >
    <Box>
      {showBack && onBack && (
        <Link
          component="button"
          variant="body2"
          onClick={onBack}
          sx={{ color: '#1B4554', textDecoration: 'none', fontWeight: 500 }}
        >
          &lt; Back to reason
        </Link>
      )}
    </Box>
    <IconButton onClick={onClose} sx={{ color: '#1B4554' }} size="small">
      <CloseIcon />
    </IconButton>
  </Box>
)

export default DrawerHeader
